<app-header [showAvatar]="false" title="Bill Run #{{billRunId}}" [useTabs]="false">
</app-header>
<div class="body">
  <div class="body-container">
    <section class="grid grid--has-padding">
      <div class="grid-content-wrapper">

        <section [@onRowStatusChange]='statusMessageBillingsItems' class="message message-grid">
          <div class="message-wrapper">
            <div class="message-inner">
              <p class="message-description">No Billing run found.</p>
            </div>
          </div>
        </section>

        <div *ngIf="isBillingRunReady && (statusMessageBillingsItems === _visibleState.isHidden)" class="grid-content">
          <mat-list class="custom-mat-list list-grid-std list-billing-operations">
            <mat-list-item class="custom-mat-list-item grid-row grid-row-header">
              <div class="cell-wrapper col-info">
                <div class="cell flex-order order-{{_meta.collectionOfMetaFields[_gridCols.billingOperationsStatus]?.priority}}">
                  <!-- [@onColumnStatusChange]="_meta.collectionOfMetaFields[_gridCols.billingOperationsStatus]?.visible"  -->
                  <label matLine class="label-header">Status</label>
                </div>
                <div [@onColumnStatusChange]="_meta.collectionOfMetaFields[_gridCols.billingOperationsInvoiceCount]?.visible" class="cell col-total flex-order order-{{_meta.collectionOfMetaFields[_gridCols.billingOperationsInvoiceCount]?.priority}}">
                  <label matLine class="label-header">Invoice No</label>
                </div>
                <div [@onColumnStatusChange]="_meta.collectionOfMetaFields[_gridCols.billingOperationsSubscriptionCount]?.visible" class="cell col-total flex-order order-{{_meta.collectionOfMetaFields[_gridCols.billingOperationsSubscriptionCount]?.priority}}">
                  <label matLine class="label-header">Subscription Bag No</label>
                </div>
                <div [@onColumnStatusChange]="_meta.collectionOfMetaFields[_gridCols.billingOperationsSubscriptionCount]?.visible" class="cell col-total flex-order order-{{_meta.collectionOfMetaFields[_gridCols.billingOperationsSubscriptionCount]?.priority}}">
                  <label matLine class="label-header">Description Code</label>
                </div>
              </div>
            </mat-list-item>
            <mat-list-item *ngFor="let item of collectionOfBillingRuns; let i = index;" class="custom-mat-list-item grid-row">
                <div class="cell-wrapper col-info">
                  <div  class="cell flex-order order-{{_meta.collectionOfMetaFields[_gridCols.billingOperationsStatus]?.priority}}">
                    <!-- [@onColumnStatusChange]="_meta.collectionOfMetaFields[_gridCols.billingOperationsStatus]?.visible" -->
                    <label matLine class="label-primary">{{item.status}}</label>
                  </div>
                  <div  class="cell col-total flex-order order-{{_meta.collectionOfMetaFields[_gridCols.billingOperationsInvoiceCount]?.priority}}">
                    <!-- [@onColumnStatusChange]="_meta.collectionOfMetaFields[_gridCols.billingOperationsInvoiceCount]?.visible" -->
                    <label *ngIf="item.invoiceId" matLine class="label-primary">
                      <a [routerLink]="['/main/invoices/',item.invoiceId,'list']" class="custom-mat-link active">#{{item.invoiceId}}</a>
                    </label>
                    <label *ngIf="!item.invoiceId" matLine class="label-primary">-</label>
                  </div>
                  <div  class="cell col-total flex-order order-{{_meta.collectionOfMetaFields[_gridCols.billingOperationsSubscriptionCount]?.priority}}">
                    <!-- [@onColumnStatusChange]="_meta.collectionOfMetaFields[_gridCols.billingOperationsSubscriptionCount]?.visible" -->
                    <label *ngIf="item.subscriptionId" matLine class="label-primary">
                      <a [routerLink]="['/main/subscriptions/',item.subscriptionId,'logs']" class="custom-mat-link active">#{{item.subscriptionId}}</a>
                    </label>
                    <label *ngIf="!item.subscriptionId" matLine class="label-primary">-</label>
                  </div>
                  <div class="cell col-total flex-order order-{{_meta.collectionOfMetaFields[_gridCols.billingOperationsSubscriptionCount]?.priority}}">
                    <label *ngIf="item.description" matLine class="label-primary">
                      {{item?.description}}
                    </label>
                    <label *ngIf="!item.description" matLine class="label-primary">-</label>
                  </div>
                </div>
            </mat-list-item>
          </mat-list>
          <div *ngIf="isBillingRunReady && gridBillingItemsTotalPages > 1" class="grid-paginator">
            <mat-paginator (page)="onPageChange($event)" color="primary" showFirstLastButtons="true" class="custom-mat-paginator" [length]="gridBillingItemsTotalItems" [pageSize]="gridBillingItemsItemsPerPage" [pageSizeOptions]="[5, 10, 25]">
            </mat-paginator>
          </div>
        </div>
        <div *ngIf="!isBillingRunReady" class="grid-content">
          <mat-list class="custom-mat-list list-grid-std list-customer-charges">
            <mat-list-item class="custom-mat-list-item grid-row grid-row-header">
              <div class="cell-wrapper col-info">
                <div class="cell col-created-on flex-order">
                  <label matline>
                    <skeleton-loader [theme]="{'width': '80px'}"></skeleton-loader>
                  </label>
                </div>
                <div class="cell col-created-on flex-order">
                  <label matline>
                    <skeleton-loader [theme]="{'width': '80px'}"></skeleton-loader>
                  </label>
                </div>
                <div class="cell col-created-on flex-order">
                  <label matline>
                    <skeleton-loader [theme]="{'width': '80px'}"></skeleton-loader>
                  </label>
                </div>
              </div>
            </mat-list-item>
            <mat-list-item class="custom-mat-list-item grid-row">
              <div class="cell-wrapper col-info">
                <div class="cell col-created-on flex-order">
                  <label matline>
                    <skeleton-loader [theme]="{'width': '80px'}"></skeleton-loader>
                  </label>
                </div>
                <div class="cell col-created-on flex-order">
                  <label matline>
                    <skeleton-loader [theme]="{'width': '80px'}"></skeleton-loader>
                  </label>
                </div>
                <div class="cell col-created-on flex-order">
                  <label matline>
                    <skeleton-loader [theme]="{'width': '80px'}"></skeleton-loader>
                  </label>
                </div>
              </div>
            </mat-list-item>
          </mat-list>
        </div>
      </div>
    </section>
  </div>
</div>
